export const options = [
  {
    optionText: 'AaBbCcDdEeFf',
    optionId: 0,
    tileColour: '#ffffff',
    textColour: '#124a57',
    classStr: 'Standard',
    isLight: true,
  },
  {
    optionId: 1,
    optionText: 'AaBbCcDdEeFf',
    tileColour: '#000000',
    textColour: '#FFFF00',
    classStr: 'Yellow',
    isLight: false,
  },
  {
    optionId: 2,
    optionText: 'AaBbCcDdEeFf',
    tileColour: '#000000',
    textColour: '#ffffff',
    classStr: 'White',
    isLight: false,
  },
  {
    optionId: 3,
    optionText: 'AaBbCcDdEeFf',
    tileColour: '#FFFF99',
    textColour: '#000000',
    classStr: 'Black',
    isLight: true,
  },
];